module.exports = __webpack_public_path__ + "img/spl-2024-sidebar-mobile.45e5919.png";